import { AfterViewInit, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroupDirective } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { AppMainService } from '../../../../app-main.service';
import { AppMainComponent } from '../../../../app.main.component';
import { Status } from '../../../../models/statusEnums';
import { QuestionnaireService } from '../../../../more/questionnaire/questionnaire.service';
import { uploadFiles, validateFiles } from '../../../../shared/upload-files';

@Component({
    selector: 'lion-questionnaire-modal',
    styleUrls: ['./app.questionnaire.modal.component.scss'],
    templateUrl: './app.questionnaire.modal.component.html',
})
export class AppQuestionnaireModalComponent implements OnChanges, AfterViewInit {

    @Input() display;
    @Input() questionnairData: [];
    @Input() visitData;

    @Output() cancelClicked = new EventEmitter();
    @Output() onCheckout = new EventEmitter();

    @ViewChild('questionnaireForm') questionnaireForm: FormGroupDirective;


    questionLists = [];
    externalLinks: any[] = [];
    questionnairsData: any = null;
    allowedImagesFileExtensions = ['.png', '.jpg', '.jpeg', '.gif'];

    selectedIds = [];
    questionAnswers = [];
    questionnaireStartTime;

    displayQuestions: boolean = false;
    chooseChannelPopup: boolean = false;
    activeIndex: number = 0;

    constructor(
        private fb: FormBuilder,
        public app: AppMainComponent,
        private appMainService: AppMainService,
        private questionnaireService: QuestionnaireService,
		private messageService: MessageService
    ) { }

    ngOnChanges(changes: SimpleChanges): void {
        ////console.log('visitData', this.visitData)
        if(changes.questionnairData && changes.questionnairData.currentValue){
            this.questionnairsData = changes.questionnairData.currentValue?.surveys||[];
            this.questionLists = [];
            this.externalLinks = [];
            this.activeIndex = 0;
            if(this.questionnairsData?.length){
                this.questionnairsData.map(questionnaireTemplate => {
                    questionnaireTemplate.selected = false;
                    questionnaireTemplate.questions = [];
                    questionnaireTemplate.surveyQuestions.map(questionObjnew =>{
                        const questionObj = {
                            id: questionObjnew.id,
                            questionnaireChannelId: questionnaireTemplate.id,
                            questionnaireId: questionnaireTemplate.id,
                            questionId: questionObjnew.id,
                            question: {...questionObjnew,questionId: questionObjnew.id, questionPreDefinedAnswerId: questionObjnew.questionOptionId}
                        }

                        questionObj.question.questionPreDefinedAnswers = (questionObjnew?.questionOptions||[]).map(questionOption=>{
                            return {
                                ...questionOption,
                                isChecked: false,
                                preDefinedAnswerValue: questionOption.value
                            }
                        })

                        const questionExits = questionnaireTemplate.questions.find(obj => obj.question.name == questionObj.question.name);
                        // this handle duplicate questions
                        if(!questionExits){
                            questionObj.questionnaireChannelId = questionnaireTemplate.id;
                            questionObj.questionnaireId = questionnaireTemplate.id;
                            if(questionObj.question.subQuestions && questionObj.question.subQuestions.length){
                                questionObj.question.subQuestions.forEach((element, idx) => {
                                    questionObj.question.subQuestions[idx] = {
                                        id: element.id,
                                        questionnaireChannelId: questionnaireTemplate.id,
                                        questionnaireId: questionnaireTemplate.id,
                                        questionId: element.id,
                                        question: {...element,questionId: element.id, questionPreDefinedAnswerId: element.questionOptionId}
                                    }

                                    questionObj.question.subQuestions[idx].question.questionPreDefinedAnswers = (element?.questionOptions||[]).map(questionOption=>{
                                        return {
                                            ...questionOption,
                                            isChecked: false,
                                            preDefinedAnswerValue: questionOption.value
                                        }
                                    })
                                });
                            }
                            questionnaireTemplate.questions.push(questionObj);
                        }
                    })
                });

                const questionLists = [];
                this.questionnairsData.map(questionnaire=>{
                    let questionsObjList = questionnaire?.questions;
                    if(questionsObjList?.length>0){
                        questionLists.push(...questionsObjList);
                    }
                });

                if(this.questionnairsData?.length==1 && questionLists?.length>0){
                    this.questionnairsData[0].selected =  true;
                    this.setQuestionnaireQuestions();
                }else if(questionLists?.length==0){
                    this.displayQuestions = true;
                }else{
                    this.chooseChannelPopup = true;
                }
            }else{
                this.displayQuestions = true;
            }

            if(this.questionLists?.length>0){
                this.activeIndex = 0;
            }else if(this.externalLinks?.length>0){
                this.activeIndex = 1;
            }
        }
    }

    ngAfterViewInit(){
        ////console.log('view initiated')
        this.questionnaireStartTime = new Date().toISOString();
    }

    setQuestionnaireQuestions(){
        const selectedQuestionnaires = this.questionnairsData.filter(questionnaire=> questionnaire?.selected)||[];

        if(selectedQuestionnaires?.length==0){
            return;
        }

        this.questionLists = [];
        this.externalLinks = [];
        selectedQuestionnaires.map(questionnaire=>{
            let questionsObjList = questionnaire?.questions;
            if(questionsObjList?.length>0){
                this.questionLists.push(...questionsObjList);
            }

            this.externalLinks.push(...questionnaire?.surveyExternalLinks||[]);
        });

        if(this.questionLists?.length>0){
            this.activeIndex = 0;
        }else if(this.externalLinks?.length>0){
            this.activeIndex = 1;
        }

        this.chooseChannelPopup = false;
        this.displayQuestions = true;
    }
    //show child subquestions
    parentAnswerSelected(id,){
        const showAnsw =  this.selectedIds.indexOf(id);
        return showAnsw >= 0 ;
    }

    checkChildQuestion(event, options){
        options.map(obj => {
            const existIndex = this.selectedIds.findIndex(s=> s==obj?.id);
            if(obj?.isChecked && existIndex<0){
                this.selectedIds.push(obj.id);
            }

            if(!obj?.isChecked && existIndex>=0){
                this.selectedIds.splice(existIndex, 1);
            }
        });
    }

    selectChildQuestion(event, options){
        ////console.log('event', event)
        // remove previously selectd child question for previous option
        options.map(obj => {
            const index = this.selectedIds.indexOf(obj.id);
            if(index >= 0){
                this.selectedIds.splice(index);
            }
        })

        this.selectedIds.push(event.value.id)
    }

    radioButtonSelected(selectedObj, options){
        ////console.log('selectedObj', selectedObj)
        ////console.log('options', options)
        options.map(obj => {
            const index = this.selectedIds.indexOf(obj.id);
            if(index >= 0){
                this.selectedIds.splice(index);
            }
        })
        this.selectedIds.push(selectedObj.id)
    }

    addQuestionsAttachment(files: File[], currentQuestion) {
		let file = files[0];
		if(file) {
            let errors = [];
            if(currentQuestion.question.formControlId == 5){
                errors = validateFiles(file, 4, this.allowedImagesFileExtensions);
            }
            if (errors.length > 0) {
                for (let error of errors) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: error.fileName + ": " + error.error });
                }
            } else {
                this.appMainService.isShowSpinner('upload');
                uploadFiles(file, ({ name, content, size, extension }) => {
                    const attachment = {
                        "id": 0,
                        "createdSource": this.app.user.userIP,
                        "updatedSource": this.app.user.userIP,
                        "createdBy": this.app.user.userId,
                        "updatedBy": 0,
                        "createdDate": new Date().toISOString(),
                        "updatedDate": new Date().toISOString(),
                        "name": name,
                        "guidName": "",
                        "location": "",
                        "content": content,
                        "extension": extension,
                        "mediaType": "",
                        "sizeInBytes": size,
                        "description": "image",
                        "statusId": Status.Active,
                        "isValid": true,
                        "validFromDate": null,
                        "validToDate": null
                    }
                    currentQuestion.attachments = [this.app.copyObjectWithoutRefrence(attachment)];
                    this.appMainService.isHideSpinner('upload');
                });
            }
		}
	}

    removeAttachment(index: number, currentQuestion) {
	    currentQuestion.attachments = []
	}

    createAnswerObj(questionAnsObj){
        // dropdown
        if(questionAnsObj.question.formControlId == 1 && questionAnsObj.question.answerValue){
            questionAnsObj.answerSelected = questionAnsObj.question.answerValue.preDefinedAnswerValue
        }
        // checkbox
        if(questionAnsObj.question.formControlId == 2 && questionAnsObj.answerSelected !=''){
            const selectedCheckboxAns= [];
            questionAnsObj.question.questionPreDefinedAnswers.map(predefinedAnswer =>{
                if(predefinedAnswer.isChecked){
                    selectedCheckboxAns.push(predefinedAnswer.preDefinedAnswerValue)
                }
            });
            questionAnsObj.answerSelected = selectedCheckboxAns.length ? selectedCheckboxAns.join(): '';
        }
        // radio
        if(questionAnsObj.question.formControlId == 3 && questionAnsObj.answerSelected && questionAnsObj.answerSelected != '' ){
            questionAnsObj.answerSelected = questionAnsObj.answerSelected
        }

        // toggle
        if(questionAnsObj.question.formControlId == 4){
             // if not answer selected default index wil be considered 1,
            if(questionAnsObj.selectedValue == undefined || questionAnsObj.selectedValue == false){
                questionAnsObj.answerSelected = questionAnsObj.question.questionPreDefinedAnswers[1].preDefinedAnswerValue;
            }
            // yes clicked
            if(questionAnsObj.selectedValue == true){
                questionAnsObj.answerSelected = questionAnsObj.question.questionPreDefinedAnswers[0].preDefinedAnswerValue;
            }
        }

        // image upload or file upload
        if(questionAnsObj.question.formControlId == 5 || questionAnsObj.question.formControlId == 6 ){
            questionAnsObj.answerSelected = questionAnsObj.attachments && questionAnsObj.attachments.length ? 'image uploaded': ''
        }

        // rating
        if(questionAnsObj.question.formControlId == 7 && questionAnsObj.answerSelected != undefined ){
            questionAnsObj.answerSelected = questionAnsObj.answerSelected
        }
    }

    addToAnswers(questionAnsObj){
        const answerObj: any = {
            "id": 0,
            "name": questionAnsObj.question.name,
            "visitId": this.visitData.visitId,
            "userId": this.app.user.userId,
            "moduleTypeId": this.visitData.objectTypeId,
            "moduleRecordId": this.visitData.objectRecordId,
            "surveyId": questionAnsObj.questionnaireId,
            "questionId": questionAnsObj.questionId,
            "answerTypeId": questionAnsObj.question.formControlId,
            "answerValue": questionAnsObj.answerSelected,
            "comment": questionAnsObj?.comment||'',
            "statusId": Status.Active,
        }
        if(questionAnsObj.attachments && questionAnsObj.attachments.length){
            answerObj.fileId = 0;
            answerObj.answerValue = '';
            answerObj.file = questionAnsObj.attachments[0];
            // answerObj.file = {
            //     "id": 0,
            //     "createdSource": this.app.user.userIP,
            //     "updatedSource": "string",
            //     "createdBy":this.app.user.userId,
            //     "updatedBy": 0,
            //     "createdDate": new Date().toISOString(),
            //     "updatedDate": new Date().toISOString(),
            //     "name": "string",
            //     "guidName": "string",
            //     "location": "string",
            //     "content": "string",
            //     "extension": "string",
            //     "mediaType": "string",
            //     "sizeInBytes": 0,
            //     "description": "string",
            //     "statusId": 2147483647,
            //     "isValid": true,
            //     "validFromDate": "2021-09-03T10:38:09.145Z",
            //     "validToDate": "2021-09-03T10:38:09.145Z"
            // }
        }
        this.questionAnswers.push(answerObj);
    }
    cancelSubmit(){
        this.cancelClicked.emit();
    }

    disableSubmitButton(){
        if(this.questionnaireForm){
            const values = Object.values(this.questionnaireForm.form.value);
            const annswerGiven = values.find(obj => obj != undefined && obj != false);
            return annswerGiven == undefined;
        } else{
            return true;
        }

    }

    submitQuestionnaire(){
        ////console.log('questionnaireForm', this.questionnaireForm)
        this.questionAnswers = [];
        if(this.questionLists.length){
            this.questionLists.map(questionAnsObj =>{
                this.createAnswerObj(questionAnsObj)
                if(questionAnsObj.answerSelected){
                    this.addToAnswers(questionAnsObj);
                     // check subquestion and its answers
                    if(questionAnsObj.question.subQuestions && questionAnsObj.question.subQuestions.length){
                        const selectedPreDefinedAnswerObj = questionAnsObj.question.questionPreDefinedAnswers.filter(obj => (obj.preDefinedAnswerValue == questionAnsObj.answerSelected) || obj?.isChecked)
                        if(questionAnsObj.question.subQuestions && selectedPreDefinedAnswerObj?.length){
                            selectedPreDefinedAnswerObj.map(preDefinedAnswerObj=>{
                                const subQuestion = questionAnsObj.question.subQuestions.find(obj =>obj.question.questionPreDefinedAnswerId == preDefinedAnswerObj.id)
                                // if answer is provided
                                if(subQuestion){
                                    this.createAnswerObj(subQuestion);
                                    if(subQuestion.answerSelected){
                                        const subQuestionObj = {
                                            question: {
                                                name: subQuestion.question.name,
                                                formControlId:subQuestion.question.formControlId
                                            },
                                            questionnaireChannelId:questionAnsObj.questionnaireChannelId,
                                            questionnaireId:questionAnsObj.questionnaireId,
                                            questionId: subQuestion.question.id,
                                            formControlId: subQuestion.question.formControlId,
                                            comment: subQuestion.comment,
                                            answerSelected: subQuestion.answerSelected
                                        }
                                        this.addToAnswers(subQuestionObj);
                                    }
                                }
                            });
                        }

                    }
                }
            })

            ////console.log('this.questionAnswers', this.questionAnswers)
            if(this.questionAnswers.length){
                this.appMainService.isShowSpinner('submitQuestionnaire');
                this.questionnaireService.submitQuestionnaire(this.questionAnswers).subscribe(
                    resp => {
                        ////console.log('submit resp', resp)
                        this.appMainService.isHideSpinner('submitQuestionnaire');

                        this.checkoutQuestionnaire();
                    },
                    err=>{
                        this.appMainService.isHideSpinner('submitQuestionnaire');
                    }
                )
            } else{
                this.messageService.add({ severity: 'error', summary: 'Error', detail:'Answer atleast one question, to checkout.' });
            }
            this.app.getAllObjects();
        } else{
            this.checkoutQuestionnaire();
        }


    }

    checkoutQuestionnaire(){
        const data = {
            "visitId": this.visitData.visitId,
            "organizationId": this.app.user.organizationId,
            "objectTypeId": this.visitData.objectTypeId,
            "objectRecordId": this.visitData.objectRecordId,
            "userId":  this.app.user.userId,
            "visitTypeId": this.visitData.visitTypeId,
            "storeLatitude":this.visitData.storeLatitude,
            "storeLongitude": this.visitData.storeLongitude,
            "checkInAddress": "",
            "checkOutAddress": "",
            "latitude": 0,
            "longitude": 0,
            "isUpdateAddress": false,
            "startDateTime": this.questionnaireStartTime,
            "endDateTime": new Date().toISOString(),
        }
        this.appMainService.isShowSpinner('checkoutQuestionnaire');
        this.questionnaireService.checkoutQuestionnaire(data).subscribe(
            resp =>{
                this.appMainService.isHideSpinner('checkoutQuestionnaire');
                this.onCheckout.emit(resp);
                this.app.getAllObjects();
            },
            err =>{
                this.appMainService.isHideSpinner('checkoutQuestionnaire');
            }
        );
    }

    /**
     * Copy the given link URL to clipboard
     * @param linkUrl URL to copy to clipboard
     */
    copyLinkToClipboard(linkUrl: string) {
        if (!linkUrl) {
            return;
        }

        navigator.clipboard.writeText(linkUrl).then(
            () => {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Link copied to clipboard!'
                });
            },
            (err) => {
                console.error('Could not copy text: ', err);
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to copy link to clipboard'
                });
            }
        );
    }

    /**
     * Open the given link URL in a new tab
     * @param linkUrl URL to open in new tab
     */
    openLinkInNewTab(linkUrl: string) {
        if (!linkUrl) {
            return;
        }

        // Handle URLs that don't start with http:// or https://
        if (!linkUrl.startsWith('http://') && !linkUrl.startsWith('https://')) {
            linkUrl = 'https://' + linkUrl;
        }

        window.open(linkUrl, '_blank');
    }
}
